import { RadioGroupPropertiesType } from "@website/ui/radio-group/radio-group.types";
import pick from "lodash-es/pick";

export const useRadioGroup = (properties: RadioGroupPropertiesType) => ({
  rootProps: {
    role: "radiogroup"
  },
  radioProps: properties.items.map((item) => ({
    ...item,
    ...pick(properties, "color", "name", "onChange", "size"),
    checked: properties.value
      ? properties.value === item.value && !item.disabled
      : undefined
  }))
});
